import { render, staticRenderFns } from "./workspace-library-legal-document-template-form.vue?vue&type=template&id=5327b9e1"
import script from "./workspace-library-legal-document-template-form.vue?vue&type=script&lang=js"
export * from "./workspace-library-legal-document-template-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports